import styled from 'styled-components';
import { Typography } from '@thinknet-gmbh/platform-common-ui';

export const ProcessTemplateWrapper = styled.div`
  & > div:first-child {
    margin-bottom: 16px;
  }
  height: 100%;

  .ant-form {
    height: 100%;
  }

  .ant-form-item {
    width: 288px;
  }
`;

export const HeaderFormContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const FormBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const FieldContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 8px;
`;

export const AssignToDetailsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const PopoverContentWrapper = styled.div`
  width: 204px;
  word-wrap: break-word;
`;

export const AssignToRow = styled(Typography)`
  text-overflow: ellipsis;
  overflow: hidden;
  width: 200px;
  height: 100%;
  white-space: nowrap;
`;
